/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TypeCountriesDto } from '../models/type-countries-dto';


/**
 * API to trigger tin verifications that we support
 */
@Injectable({
  providedIn: 'root',
})
export class VerificationSupportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation support
   */
  static readonly SupportPath = '/verifications';

  /**
   * Trigger supported verifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `support()` instead.
   *
   * This method doesn't expect any request body.
   */
  support$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<TypeCountriesDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationSupportService.SupportPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeCountriesDto>>;
      })
    );
  }

  /**
   * Trigger supported verifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `support$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  support(params?: {
  },
  context?: HttpContext

): Observable<Array<TypeCountriesDto>> {

    return this.support$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<TypeCountriesDto>>) => r.body as Array<TypeCountriesDto>)
    );
  }

}
